import { Component, OnInit } from '@angular/core';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kisok-advanced-products',
  templateUrl: './kisok-advanced-products.component.html',
  styleUrls: ['./kisok-advanced-products.component.css']
})
export class KisokAdvancedProductsComponent implements OnInit {

  constructor(
    private kioskStateService: KioskStateService,
  ) { }

  ngOnInit() {
  }

  onBackwardClick() {
    this.kioskStateService.update(KioskStateEnum.SelectBookingEventProducts);
  }

  onForwardClick() {
    this.kioskStateService.update(KioskStateEnum.LoginOrRegister);
  }

}
